import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheSpiritOfUmami from "./sections/TheSpiritOfUmami";
import OurSecretIngredients from "./sections/OurSecretIngredients";
import MeasurableInclusion from "./sections/MeasurableInclusion";
import IlProcessoDiScelta from "./sections/IlProcessoDiScelta";
import StimmenUnsererKunden from "./sections/StimmenUnsererKunden";
import LetsMakeItSimple from "./sections/LetsMakeItSimple";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheSpiritOfUmami />
      <OurSecretIngredients />
      <MeasurableInclusion />
      <IlProcessoDiScelta />
      <StimmenUnsererKunden />
      <LetsMakeItSimple />
      <Footer />
    </div>;
}